import {ChangeDetectorRef, Component, EventEmitter, forwardRef, Input, OnDestroy, OnInit, Output} from "@angular/core";
import {AbstractVisbosControl} from "../../../core/visbos-core/ui/forms/abstract-visbos-control";
import {Product} from "../../../shared/view-model/store-management/product.type";
import {FormBuilder, FormControl} from "@angular/forms";
import {appInjector} from "../../../index";
import {StockItem} from "../../../shared/view-model/store-management/stock-item.type";

@Component({
  selector: 'vb-product-selection',
  templateUrl: './product-selection.component.html',
  styleUrls: ['./product-selection.component.css'],
  providers: [{provide: AbstractVisbosControl, useExisting: forwardRef(() => ProductSelectionComponent)}]
})
export class ProductSelectionComponent extends AbstractVisbosControl<Product, FormControl> implements OnInit, OnDestroy {

  products: Product[] = [];
  defaultProduct: Product;

  private _stockItem: StockItem;

  get stockItem(): StockItem {
    return this._stockItem;
  }

  @Input()
  set stockItem(value: StockItem) {
    this._stockItem = value;

    this.products = value ? value.products : [];

    if (!this.products) {
      return;
    }

    this.defaultProduct = this.products.find(pr => pr.default_product);
    this.item = this.defaultProduct;

  }

  @Output()
  productSelected: EventEmitter<Product> = new EventEmitter();

  constructor(fb: FormBuilder, cd: ChangeDetectorRef) {
    super(fb, cd, null);
  }

  ngOnInit() {
    super.ngOnInit();
  }

  ngOnDestroy(): void {

  }

  buildControlContent(): FormControl {
    return ProductSelectionComponent.initControl(this.fb,);
  }

  public static initControl(fb: FormBuilder = null,): FormControl {
    fb = fb ? fb : appInjector().get(FormBuilder);
    return fb.control(null);
  }

  public setDefaultValues(item?: Product): {[controlKey: string]: any} | any {
    return this.setValue(item, 'cuid');
  }

  onProductSelected(product: Product) {
    this.productSelected.emit(product);
  }

}



// WEBPACK FOOTER //
// ./src/app/store-management/product/product-selection/product-selection.component.ts